var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sl-content',{attrs:{"pagetype":"2","pagename":"slinfrastructurecybersecurity","title":_vm.$t('sl.infrastructure.title'),"titlecolor":"lightgreen"}})}
var staticRenderFns = []

export { render, staticRenderFns }